import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { oneLine } from 'common-tags';
import { member123 } from './member';
export var corporateRedo = {
  __typename: 'ActivityTimelineCorporateRedo',
  typeCode: 'corporate_redo',
  createdAt: '2021-05-13T15:42:00.188668Z',
  message: "You've been asked to redo a stage.",
  iconUrl: null,
  feedback: oneLine(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    You did a bad job, but I'll let you try again. Your response was great, but we would \n    love if you could provide more feedback about lorem ipsum dolor sit amet, consectetur \n    adipiscing elit. Praesent ullamcorper, mi et porta sollicitudin."]))),
  admin: member123
};
export var corporateConfirmation = {
  __typename: 'ActivityTimelineCorporateConfirmation',
  typeCode: 'corporate_confirmation',
  createdAt: '2021-05-13T15:42:00.188668Z',
  message: 'This challenge has been advanced to the next stage by {{sender.name}}.',
  iconUrl: null,
  feedback: 'Wow great job! Enjoy moving onto the next stage.',
  admin: member123
};
export var challengeRejected = {
  __typename: 'ActivityTimelineChallengeRejected',
  typeCode: 'challenge_rejected',
  createdAt: '2021-05-13T15:42:00.188668Z',
  message: 'Your submission has been declined.',
  iconUrl: null,
  feedback: "You did such a bad job I'm not letting you try again.",
  admin: member123
};
export var questions = {
  __typename: 'ActivityTimelineQuestions',
  typeCode: 'questions',
  createdAt: '2021-05-13T15:42:00.188668Z',
  message: 'You have completed this question stage',
  iconUrl: null
};
export var completedChallenge = {
  __typename: 'ActivityTimelineCompletedChallenge',
  typeCode: 'completed_challenge',
  createdAt: '2021-05-13T15:42:00.188668Z',
  message: "Awesome!  You've completed this challenge.",
  iconUrl: null
};